import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom'; // se usi react-router
import { verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';
import { logEvent } from 'firebase/analytics';
import { auth, analytics } from '../../firebase'; // percorso corretto al tuo auth

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const oobCode = searchParams.get('oobCode');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('verifying'); // verifying | valid | error | success
  const [error, setError] = useState('');

  useEffect(() => {
    if (!oobCode) {
      setStatus('error');
      setError('Codice mancante.');
      return;
    }

    verifyPasswordResetCode(auth, oobCode)
      .then(email => {
        setEmail(email);
        setStatus('valid');
      })
      .catch(err => {
        console.error(err);
        setStatus('error');
        setError('Il link di reset non è valido o è scaduto.');
      });
  }, [oobCode]);

  const handleReset = async e => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Le password non coincidono.');
      return;
    }

    try {
      await confirmPasswordReset(auth, oobCode, newPassword);
      logEvent(analytics, 'password_reset_success');
      setStatus('success');
      setTimeout(() => navigate('/login'), 3000); // redirect dopo 3 sec
    } catch (err) {
      console.error(err);
      setError('Errore nel reimpostare la password. Riprova.');
    }
  };

  return (
    <div className="mx-auto mt-10 max-w-md rounded bg-white p-6 shadow">
      <h2 className="mb-4 text-center text-2xl font-semibold">Reimposta la password</h2>

      {status === 'verifying' && (
        <p className="text-sm text-gray-500">Verifica del link in corso...</p>
      )}

      {status === 'error' && <p className="text-sm text-red-600">{error}</p>}

      {status === 'valid' && (
        <form onSubmit={handleReset} className="space-y-4">
          <p className="text-sm text-gray-700">
            Stai reimpostando la password per: <strong>{email}</strong>
          </p>

          {error && <p className="text-sm text-red-500">{error}</p>}

          <div>
            <label htmlFor="password" className="mb-1 block">
              Nuova password
            </label>
            <input
              id="password"
              type="password"
              className="w-full rounded border p-2"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
            />
          </div>

          <div>
            <label htmlFor="password-confirm" className="mb-1 block">
              Conferma password
            </label>
            <input
              id="password-confirm"
              type="password"
              className="w-full rounded border p-2"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full rounded bg-primary py-2 text-white hover:bg-primary"
          >
            Reimposta password
          </button>
        </form>
      )}

      {status === 'success' && (
        <p className="text-center text-sm text-green-600">
          Password aggiornata con successo! Verrai reindirizzato al login...
        </p>
      )}
    </div>
  );
};

export default ResetPassword;
